/** Placeholder when a leaf has no live URL yet. TODO: fill remaining hrefs */
export const RESOURCES_LINK_PLACEHOLDER = "#";

const link = (id, label, href = RESOURCES_LINK_PLACEHOLDER) => ({
  id,
  label,
  href: href || RESOURCES_LINK_PLACEHOLDER,
});

const group = (id, label, children) => ({ id, label, children });

export const isResourcesLeaf = (node) =>
  !Array.isArray(node?.children) || node.children.length === 0;

export const RESOURCES_MENU = [
  group("o-level", "O Level", [
    group("o-maths", "Maths", [
      link(
        "o-maths-class-notes",
        "Class notes",
        "https://drive.google.com/drive/folders/1khABDthjuy-ss5Kup3yE8xn8Bd-bIc-t?usp=sharing",
      ),
      link(
        "o-maths-unsolved-worksheets",
        "Unsolved worksheets",
        "https://drive.google.com/drive/folders/1bhpW8OCeyMJiunJ1w69haFOxw6jXk7OX?usp=sharing",
      ),
      link(
        "o-maths-solved-worksheets",
        "Solved worksheets",
        "https://drive.google.com/drive/folders/1g4E_nlQTrjOtfwTvGYnZaRVqNk7opRxj?usp=share_link",
      ),
      link(
        "o-maths-study-plan",
        "Study plan",
        "https://docs.google.com/spreadsheets/d/18xChgpA2EQDLKtF6M5R0Eav3sNLCI8LzFHDlGtecaYs/edit?usp=sharing",
      ),
      link(
        "o-maths-progress-checklist",
        "Progress checklist",
        "https://docs.google.com/spreadsheets/d/1UJV0DnRKFpePKvxFLO-uyOl2IAzG0zIz4wOhNDclm4o/edit?usp=sharing",
      ),
    ]),
    group("o-physics", "Physics", [
      link(
        "o-physics-class-notes",
        "Class notes",
        "https://drive.google.com/drive/folders/11UHBsL-_FPn7lnjmAs_MGLBKFpI6Rl9q?usp=drive_link",
      ),
      link(
        "o-physics-past-paper-session-2024",
        "Past paper session 2024",
        "https://drive.google.com/drive/folders/11dXsqFgpmhfOeAy28n0G9QrkRu_EULG2?usp=drive_link",
      ),
      link(
        "o-physics-books",
        "Books",
        "https://drive.google.com/drive/folders/1-cqQZKLkeq0-bnOE540_XShnNCBRRJFM?usp=drive_link",
      ),
    ]),
    group("o-economics", "Economics", [
      link(
        "o-economics-class-notes",
        "Class notes",
        "https://drive.google.com/drive/folders/1siH4mp13COOpQ2Q3iDtrATQvryblJy8J",
      ),
      link(
        "o-economics-unsolved-worksheets",
        "Unsolved worksheets",
        "https://drive.google.com/drive/folders/1IToilL1o-he9piKR-ZofSevYQqF9mlzI?usp=drive_link",
      ),
      link(
        "o-economics-solved-worksheets",
        "Solved worksheets",
        "https://drive.google.com/drive/folders/19E0F_K3DhDSVCWozD7mx3hNoHB1MomXJ?usp=sharing",
      ),
      // link("o-economics-study-plan", "Study plan"),
      // link("o-economics-progress-checklist", "Progress checklist"),
    ]),
    group("o-business", "Business", [
      link(
        "o-business-class-notes",
        "Class notes",
        "https://drive.google.com/drive/folders/1asQkdfMDeXx7g4abRAymf81YjvfCu7Fk?usp=sharing",
      ),
      link(
        "o-business-unsolved-worksheets",
        "Unsolved worksheets",
        "https://drive.google.com/drive/folders/15Y8JJIrBZN8dxdjT4JzbNlRWaF3QnbM-?usp=drive_link",
      ),
      link(
        "o-business-solved-worksheets",
        "Solved worksheets",
        "https://drive.google.com/drive/folders/1dvs1mOGT6lM7E2UUUuw20DX0_ts3tWGr?usp=sharing",
      ),
      // link("o-business-study-plan", "Study plan"),
      // link("o-business-progress-checklist", "Progress checklist"),
    ]),
    group("o-accounting", "Accounting", [
      link(
        "o-accounting-class-notes",
        "Class notes",
        "https://drive.google.com/drive/folders/1jdSKyVdAkom5uarKZjA8sMn1Q96zzHI_",
      ),
      // link(
      //   "o-accounting-unsolved-worksheets",
      //   "Unsolved worksheets",
      // ),
      link(
        "o-accounting-solved-worksheets",
        "Solved worksheets",
        "https://drive.google.com/drive/folders/1LSV7u-YBl2L7CCyC7pmZ16QpPQ98Mk_Y",
      ),
      // link("o-accounting-study-plan", "Study plan"),
      link(
        "o-accounting-progress-checklist",
        "Progress checklist",
        "https://docs.google.com/spreadsheets/d/1RHDzePo_wSoyiahRagH2hs4Z32MzZDOd/edit?usp=drivesdk&ouid=114954575325245738266&rtpof=true&sd=true",
      ),
    ]),
    group("o-computer-science", "Computer Science", [
      group("o-cs-p1", "P1", [
        link(
          "o-cs-p1-playlist",
          "Full syllabus playlist",
          "https://www.youtube.com/playlist?list=PLLyqGZba3Xv14byYtlIpU5cZQkVIBzvMO",
        ),
        link(
          "o-cs-p1-notes-pdf",
          "Class notes (pdf)",
          "https://drive.google.com/drive/folders/1kLPqAEP9P3_2-wWpdkL2OqP1LVjn3fM2",
        ),
        link(
          "o-cs-p1-notes-notion",
          "Class notes (notion)",
          "https://app.notion.com/p/O-Levels-Computer-Science-2210-21886d67bd24807a8cb9e3512e44cdc8",
        ),
        link(
          "o-cs-p1-topical-unsolved",
          "Topical worksheets (unsolved)",
          "https://drive.google.com/drive/folders/16Xk_RqvdFVmYAHK14hOe5H9B-Iycrdd9",
        ),
      ]),
      group("o-cs-p2", "P2", [
        link(
          "o-cs-p2-playlist",
          "Full syllabus playlist",
          "https://www.youtube.com/playlist?list=PLLyqGZba3Xv1esH57AkYbOUV9ds-pGsNv",
        ),
        link(
          "o-cs-p2-notes-pdf",
          "Class notes (pdf)",
          "https://drive.google.com/drive/folders/1lL2gvXRZs-HMU6zpW0DtV1ojVNvraOm8",
        ),
        link(
          "o-cs-p2-topical-unsolved",
          "Topical worksheets (unsolved)",
          "https://drive.google.com/drive/folders/11zV4Sc3lSHpdrBTZfWu7fYA_Oc68v9OB",
        ),
      ]),
    ]),
  ]),
  group("a-level", "A Level", [
    group("a-maths", "Maths", [
      group("a-maths-p1", "P1", [
        link(
          "a-maths-p1-class-notes",
          "Class notes",
          "https://drive.google.com/drive/folders/1KLbnNVScQhcZ1StxOpRSxHqQnCCMaaXf?usp=share_link",
        ),
        link(
          "a-maths-p1-unsolved-worksheets",
          "Unsolved worksheets",
          "https://drive.google.com/drive/folders/13JREtJKAkm74qC0z9XagyXPX87t1yS9I",
        ),
        link(
          "a-maths-p1-solved-worksheets",
          "Solved worksheets",
          "https://drive.google.com/drive/folders/17QPceQ221xvLllmFvIlDibaGbTYXwJkV?usp=share_link",
        ),
        link(
          "a-maths-p1-study-plan",
          "Study plan",
          "https://youtu.be/IHV6BhObKoo?si=OnjsILfA6JNL37L9",
        ),
        link(
          "a-maths-p1-progress-checklist",
          "Progress checklist",
          "https://docs.google.com/spreadsheets/d/1PzAS_1NEGn4J1KBi88YHPbQMMb5koFtIL3QBx_NuhUU/edit#gid=855129015",
        ),
      ]),
      group("a-maths-p3", "P3", [
        link(
          "a-maths-p3-class-notes",
          "Class notes",
          "https://drive.google.com/drive/folders/1WDlKsKQId6vX7RSawueSHBPmj4lEbG8y?usp=share_link",
        ),
        link(
          "a-maths-p3-unsolved-worksheets",
          "Unsolved worksheets",
          "https://drive.google.com/drive/folders/1hHPn7pOt7iuTNXeDkJO5hCcX0svYx-d6?usp=share_link",
        ),
        link(
          "a-maths-p3-solved-worksheets",
          "Solved worksheets",
          "https://drive.google.com/drive/folders/1AWnIydrI4t62q8dOcx2HNBGlUZxx6dP2?usp=share_link",
        ),
        link(
          "a-maths-p3-study-plan",
          "Study plan",
          "https://youtu.be/IHV6BhObKoo?si=OnjsILfA6JNL37L9",
        ),
        link(
          "a-maths-p3-progress-checklist",
          "Progress checklist",
          "https://docs.google.com/spreadsheets/d/1PzAS_1NEGn4J1KBi88YHPbQMMb5koFtIL3QBx_NuhUU/edit#gid=1626488398",
        ),
      ]),
      group("a-maths-m1", "M1", [
        link(
          "a-maths-m1-class-notes",
          "Class notes",
          "https://drive.google.com/drive/folders/1BmvFSs17miZjzxx5WVcbIrsGW-PPG1a8?usp=share_link",
        ),
        link(
          "a-maths-m1-unsolved-worksheets",
          "Unsolved worksheets",
          "https://drive.google.com/drive/folders/1SPgqolI1EX2xRwqqk9dSzlP3b4hGFo_M",
        ),
        link(
          "a-maths-m1-solved-worksheets",
          "Solved worksheets",
          "https://drive.google.com/drive/folders/1DiwUHkbmWtcXL6k3Wn785uJbsdbfFJc-?usp=share_link",
        ),
        link(
          "a-maths-m1-study-plan",
          "Study plan",
          "https://youtu.be/IHV6BhObKoo?si=OnjsILfA6JNL37L9",
        ),
        link(
          "a-maths-m1-progress-checklist",
          "Progress checklist",
          "https://docs.google.com/spreadsheets/d/1PzAS_1NEGn4J1KBi88YHPbQMMb5koFtIL3QBx_NuhUU/edit#gid=909086046",
        ),
      ]),
      group("a-maths-s1", "S1", [
        link(
          "a-maths-s1-class-notes",
          "Class notes",
          "https://drive.google.com/drive/folders/15REX67GF7d9gZVHPuQ_A39pi9tHS4KEq?usp=share_link",
        ),
        link(
          "a-maths-s1-unsolved-worksheets",
          "Unsolved worksheets",
          "https://drive.google.com/drive/folders/1pJ_euBJ94e0jtYe3l7H0Q_UYyYumukTY?usp=share_link",
        ),
        link(
          "a-maths-s1-solved-worksheets",
          "Solved worksheets",
          "https://drive.google.com/drive/folders/1CMLWwovgycAz0AsxGENjpt4Fu1_xXTxZ?usp=share_link",
        ),
        link(
          "a-maths-s1-study-plan",
          "Study plan",
          "https://youtu.be/IHV6BhObKoo?si=OnjsILfA6JNL37L9",
        ),
        link(
          "a-maths-s1-progress-checklist",
          "Progress checklist",
          "https://docs.google.com/spreadsheets/d/1PzAS_1NEGn4J1KBi88YHPbQMMb5koFtIL3QBx_NuhUU/edit#gid=234865498",
        ),
      ]),
    ]),
    group("a-physics", "Physics", [
      group("a-physics-as", "AS", [
        link(
          "a-physics-as-class-notes",
          "Class notes",
          "https://drive.google.com/drive/folders/13P4GpFWRoJPMC1qf24TeUNBObxUFCbLQ?usp=drive_link",
        ),
        link(
          "a-physics-as-past-paper-resources",
          "Past paper resources",
          "https://drive.google.com/drive/folders/10keGhuznhNU2c0vYDzlIZQ9PAx7N3UsM?usp=drive_link",
        ),
        link(
          "a-physics-as-past-paper-session-2024",
          "Past paper session 2024",
          "https://drive.google.com/drive/folders/14EvyzulLv2l2b5xZqPYmqHLp9DLHUno7?usp=drive_link",
        ),
        link(
          "a-physics-as-practical-paper-3-syllabus",
          "Practical paper 3 syllabus",
          "https://drive.google.com/drive/folders/13Pu_r34Un85CKsGnXUsqamSPr5_lBwcu?usp=drive_link",
        ),
        link(
          "a-physics-as-books",
          "Books",
          "https://drive.google.com/drive/folders/1-D7sqLAEoZlgICNdYnpoEcKpTY4fDxf6?usp=drive_link",
        ),
      ]),
      group("a-physics-a2", "A2", [
        link(
          "a-physics-a2-class-notes",
          "Class notes",
          "https://drive.google.com/drive/folders/136se0dvXMkE-7VVlcel5lg6ohHbryLYu?usp=drive_link",
        ),
        link(
          "a-physics-a2-past-paper-resources",
          "Past paper resources",
          "https://drive.google.com/drive/folders/138_RQpj0fjC86XYatIZ9IuS9qc3B7uxZ?usp=drive_link",
        ),
        link(
          "a-physics-a2-past-paper-session-2024",
          "Past paper session 2024",
          "https://drive.google.com/drive/folders/134VOI3R1ivKVLx52MgWenm8wLRFyNjyH?usp=drive_link",
        ),
        link(
          "a-physics-a2-books",
          "Books",
          "https://drive.google.com/drive/folders/14LK422IOx0JAl7rGrk7Ha-J-ut1Ifobr?usp=drive_link",
        ),
      ]),
    ]),
    group("a-computer-science", "Computer Science", [
      group("a-cs-p1", "P1", [
        link(
          "a-cs-p1-playlist",
          "Full syllabus playlist",
          "https://www.youtube.com/playlist?list=PLLyqGZba3Xv2fvMPcLUwnD_Yb2FcNP2qz",
        ),
        link(
          "a-cs-p1-notes-pdf",
          "Class notes (pdf)",
          "https://drive.google.com/drive/folders/1n4V9kdOgawqLxGRosy4BRhnyhp-tNbVs",
        ),
        link(
          "a-cs-p1-annotated-notes-pdf",
          "Annotated class notes (pdf)",
          "https://drive.google.com/drive/folders/1SLUnUDQfaU0H3EU6SgmIh1s0mg9IU_CL",
        ),
        link(
          "a-cs-p1-notes-notion",
          "Class notes (notion)",
          "https://brawny-canid-46b.notion.site/1f586d67bd24801ba52ccff7f2455cea?v=1f586d67bd248084a620000c3d258839",
        ),
        link(
          "a-cs-p1-topical-unsolved",
          "Topical worksheets (unsolved)",
          "https://drive.google.com/drive/folders/1o5uXF_npCs2vzHHX5illAfhZKjze1USC",
        ),
      ]),
      group("a-cs-p2", "P2", [
        link(
          "a-cs-p2-playlist",
          "Full syllabus playlist",
          "https://www.youtube.com/playlist?list=PLLyqGZba3Xv061lRqD-2Ur95egLkWXvTG",
        ),
        link(
          "a-cs-p2-notes-pdf",
          "Class notes (pdf)",
          "https://drive.google.com/drive/folders/12LoyeZ6EkioiY8k0KWL475nibe5p6qNx",
        ),
        link(
          "a-cs-p2-topical-unsolved",
          "Topical worksheets (unsolved)",
          "https://drive.google.com/drive/folders/111jxEa7WNvRBedHMrX_0wPy-KJ1IbXcD",
        ),
      ]),
      link(
        "a-cs-p3",
        "P3",
        "https://1drv.ms/o/s!Av_8lM3EFhYbj2zBV2XENMkDPLNW?e=BbSKsj",
      ),
      link(
        "a-cs-p4",
        "P4",
        "https://drive.google.com/drive/folders/1NqId9cijTXMJuSkuusPv3G1MCe1sQi8x?usp=drive_link",
      ),
    ]),
    link(
      "a-accounting",
      "Accounting",
      "https://drive.google.com/drive/folders/1RoR5XymTGaNnWBMoKxjgoJd3Khj0yIY8",
    ),
  ]),
];
